var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"appInner",style:({height:_vm.isShow?'':'100%'})},[_c('router-view')],1),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }